import el from "@cypherpotato/el";
import { MutedText } from "./text";

export function BigTextPreview(text, lang) {

    const lines = text?.nullWhenEmpty()?.split("\n").slice(0, 5) ?? [];
    
    return el("div.big-text-preview",
        lang == null && text && (
            el("pre", lines.join("\n"))
        ),
        lang != null && text && (
            el("pre",
                el("code.language-" + lang,
                    lines.join("\n")
                ),
                {
                    mount() {
                        Prism.highlightAll();
                    }
                }
            )
        ),
        lines.length == 0 && MutedText("Empty")
    );
}